import React from 'react';
import { db } from './firebase';
import { doc, getDoc, setDoc, updateDoc, increment } from "firebase/firestore";

// Rutas limpias y correctas apuntando a la carpeta Componentes
import PropietarioMantenimiento from './Componentes/PropietarioMantenimiento';
import PropietarioReservas from './Componentes/PropietarioReservas';
import PropietarioComunicados from './Componentes/PropietarioComunicados';
import PropietarioInformes from './Componentes/PropietarioInformes';
import PropietarioPersonal from './Componentes/PropietarioPersonal';

export default function PropietarioPortal({
  usuarioLogueado,
  pestanaPropietario,
  setPestanaPropietario,
  anioSeleccionadoProp,
  setAnioSeleccionadoProp,
  cuotasPropietarioPorAnio,
  formatearMonto,
  subiendoVoucherPropId,
  subirVoucherPropietario,
  areasSociales,
  formReserva,
  setFormReserva,
  crearReserva,
  reservas,
  anioInforme,
  setAnioInforme,
  mesInforme,
  setMesInforme,
  informesFiltrados,
  comunicados,
  documentosPermanentes
}) {

  // Función global en Firebase para limitar la visualización de archivos a un máximo de 5 veces al día (reseteo exacto a medianoche hora local)
  const abrirArchivoConLimiteGlobal = async (fileUrl, fileId) => {
    if (!fileUrl) {
      alert("⚠️ El archivo aún no está disponible.");
      return;
    }

    const idPropietario = usuarioLogueado?.departamento?.departamento || 'general';
    
    // Obtenemos la fecha local exacta del dispositivo (evita el desfase UTC de las 7:00 PM)
    const fechaLocal = new Date();
    const anio = fechaLocal.getFullYear();
    const mes = String(fechaLocal.getMonth() + 1).padStart(2, '0');
    const dia = String(fechaLocal.getDate()).padStart(2, '0');
    const hoy = `${anio}-${mes}-${dia}`;

    const registroId = `${idPropietario}_${fileId}_${hoy}`;
    const docRef = doc(db, "control_vistas_archivos", registroId);

    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const datos = docSnap.data();
        if (datos.contador >= 5) {
          alert("❌ Has alcanzado el límite máximo global de 5 visualizaciones permitidas para este documento el día de hoy.");
          return;
        }
        await updateDoc(docRef, { contador: increment(1) });
      } else {
        await setDoc(docRef, { propietarioId: idPropietario, archivoId: fileId, fecha: hoy, contador: 1 });
      }

      window.open(fileUrl, '_blank');
    } catch (error) {
      console.error("Error al verificar el límite global:", error);
      alert("Ocurrió un error al verificar el acceso al documento.");
    }
  };

  return (
    <div style={{ maxWidth: '1000px', width: '100%', margin: '20px auto', padding: '0 15px', textAlign: 'left', boxSizing: 'border-box' }}>
      
      {/* Tarjeta de Bienvenida limpia sin logotipo */}
      <div style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '12px', padding: '25px', marginBottom: '20px' }}>
        <span style={{ backgroundColor: '#16a34a', color: 'white', padding: '4px 10px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold', textTransform: 'uppercase' }}>Portal del Propietario</span>
        <h2 style={{ margin: '10px 0 5px 0', color: '#166534' }}>Bienvenido(a), {usuarioLogueado.departamento.nombre}</h2>
        <p style={{ margin: 0, color: '#15803d', fontSize: '0.95rem' }}>🏢 Edificio <strong>{usuarioLogueado.edificioNombre}</strong> — Departamento <strong>{usuarioLogueado.departamento.departamento}</strong></p>
      </div>

      {/* ⚠️ ALERTA VISUAL DE BLOQUEO POR MOROSIDAD O FALTA DE PAGO */}
      {usuarioLogueado?.departamento?.bloqueadoReservas && (
        <div style={{ backgroundColor: '#fee2e2', border: '1px solid #fecaca', color: '#991b1b', padding: '15px 20px', borderRadius: '10px', marginBottom: '20px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '1.2rem' }}>🚫</span>
          <div>
            <p style={{ margin: '0 0 3px 0' }}>Sus reservas de áreas sociales se encuentran temporalmente suspendidas.</p>
            <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: 'normal', color: '#b91c1c' }}>Por favor, regularice sus cuotas de mantenimiento pendientes o comuníquese con la administración.</p>
          </div>
        </div>
      )}

      {/* Botones de Pestañas Superiores del Propietario */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '25px', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', flexWrap: 'wrap' }}>
        <button 
          onClick={() => setPestanaPropietario('mantenimiento')} 
          style={{ backgroundColor: pestanaPropietario === 'mantenimiento' ? '#0284c7' : '#f1f5f9', color: pestanaPropietario === 'mantenimiento' ? 'white' : '#334155', border: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          📄 Mis Cuotas y Vouchers de Pago
        </button>
        <button 
          onClick={() => setPestanaPropietario('reservas')} 
          style={{ backgroundColor: pestanaPropietario === 'reservas' ? '#0284c7' : '#f1f5f9', color: pestanaPropietario === 'reservas' ? 'white' : '#334155', border: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          🎉 Reserva de Áreas Sociales
        </button>
        <button 
          onClick={() => setPestanaPropietario('comunicados')} 
          style={{ backgroundColor: pestanaPropietario === 'comunicados' ? '#0284c7' : '#f1f5f9', color: pestanaPropietario === 'comunicados' ? 'white' : '#334155', border: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          📢 Comunicados
        </button>
        <button 
          onClick={() => setPestanaPropietario('informe')} 
          style={{ backgroundColor: pestanaPropietario === 'informe' ? '#0284c7' : '#f1f5f9', color: pestanaPropietario === 'informe' ? 'white' : '#334155', border: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          🏢 Gestión y Archivo
        </button>
        <button 
          onClick={() => setPestanaPropietario('personal')} 
          style={{ backgroundColor: pestanaPropietario === 'personal' ? '#0284c7' : '#f1f5f9', color: pestanaPropietario === 'personal' ? 'white' : '#334155', border: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}
        >
          👷 Personal del Edificio
        </button>
      </div>

      {/* RENDERIZADO DE LOS COMPONENTES SEGÚN LA PESTAÑA ACTIVA */}
      {pestanaPropietario === 'mantenimiento' && (
        <PropietarioMantenimiento
          anioSeleccionadoProp={anioSeleccionadoProp}
          setAnioSeleccionadoProp={setAnioSeleccionadoProp}
          cuotasPropietarioPorAnio={cuotasPropietarioPorAnio}
          formatearMonto={formatearMonto}
          subiendoVoucherPropId={subiendoVoucherPropId}
          subirVoucherPropietario={subirVoucherPropietario}
          abrirArchivoConLimiteGlobal={abrirArchivoConLimiteGlobal}
        />
      )}

      {pestanaPropietario === 'reservas' && (
        <PropietarioReservas
          usuarioLogueado={usuarioLogueado}
          areasSociales={areasSociales}
          reservas={reservas}
          formReserva={formReserva}
          setFormReserva={setFormReserva}
          abrirArchivoConLimiteGlobal={abrirArchivoConLimiteGlobal}
        />
      )}

      {pestanaPropietario === 'informe' && (
        <PropietarioInformes
          anioInforme={anioInforme}
          setAnioInforme={setAnioInforme}
          mesInforme={mesInforme}
          setMesInforme={setMesInforme}
          informesFiltrados={informesFiltrados}
          abrirArchivoConLimiteGlobal={abrirArchivoConLimiteGlobal}
          documentosPermanentes={documentosPermanentes}
        />
      )}

      {pestanaPropietario === 'personal' && (
        <PropietarioPersonal
          usuarioLogueado={usuarioLogueado}
        />
      )}

      {pestanaPropietario === 'comunicados' && (
        <PropietarioComunicados
          comunicados={comunicados}
        />
      )}

    </div>
  );
}